import { useCallback, useEffect, useState } from "react";

const useFabPeek = (open, appLoading) => {
  const [expanded, setExpanded] = useState(false);
  const [wiggle, setWiggle] = useState(false);

  useEffect(() => {
    if (open || appLoading) return undefined;
    let collapseTimer;
    const peek = () => {
      setExpanded(true);
      collapseTimer = setTimeout(() => setExpanded(false), 3000);
    };
    const startTimer = setTimeout(peek, 1000);
    const expandInterval = setInterval(peek, 8000);
    const wiggleInterval = setInterval(() => {
      setWiggle(true);
      setTimeout(() => setWiggle(false), 500);
    }, 4000);

    return () => {
      clearTimeout(startTimer);
      clearTimeout(collapseTimer);
      clearInterval(expandInterval);
      clearInterval(wiggleInterval);
    };
  }, [open, appLoading]);

  const reset = useCallback(() => {
    setExpanded(false);
    setWiggle(false);
  }, []);

  return { expanded, wiggle, reset };
};

export default useFabPeek;
